const comments = [
  {
    name: '光影旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20with%20stylish%20haircut%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20gray%20background%2C%20friendly%20smile%2C%20sharp%20focus%2C%20minimalist%20portrait%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    date: '2小时前',
    content: '画质真的太棒了！之前在其他平台看同一部电影总是卡顿，酷客影院的超清播放体验完全不一样，加载很快而且从头到尾没缓冲过。已经推荐给身边的朋友了！',
    rating: 5,
  },
  {
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20elegant%20style%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background%2C%20natural%20confident%20expression%2C%20minimalist%20portrait%20photography%2C%20warm%20tones&width=120&height=120&seq=avatar-02&orientation=squarish',
    date: '5小时前',
    content: '片库真的很大！想看的冷门老片居然都有高清资源，搜索也很方便。现在每天晚上固定打开酷客影院挑一部看，成了我和室友的保留节目。',
    rating: 5,
  },
  {
    name: '电影发烧友Leo',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%20thirties%2C%20wearing%20glasses%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20gray%20background%2C%20thoughtful%20expression%2C%20intellectual%20style%2C%20minimalist%20portrait&width=120&height=120&seq=avatar-03&orientation=squarish',
    date: '1天前',
    content: '作为一个重度影迷，对画质要求很高。酷客影院的1080P超清真的没话说，暗部细节清晰，色彩还原度很高。支持多设备无缝切换这点也特别实用。',
    rating: 4,
  },
  {
    name: '周末放映员',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20smiling%20warmly%2C%20casual%20stylish%20look%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background%2C%20friendly%20approachable%20expression%2C%20minimalist%20portrait%20photography&width=120&height=120&seq=avatar-04&orientation=squarish',
    date: '2天前',
    content: '分类做得很用心，古装、科幻、纪录片都有独立专区。长安十二时辰的画质修复版太惊艳了！希望平台能持续保持这个更新速度，每天都来看看有没有新片上架。',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
            真实反馈
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            观众热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            听听影迷们怎么说 —— 每一份好评都是我们前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/50">
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover shrink-0"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{c.name}</span>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, si) => (
                        <i
                          key={si}
                          className={`text-xs ${si < c.rating ? 'text-accent-500 ri-star-fill' : 'text-background-300 ri-star-line'}`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <span className="text-xs text-foreground-400">{c.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}